var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_217_734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 8.30516e-07L1 4.37114e-08C0.400001 1.74846e-08 8.56744e-07 0.4 8.30517e-07 1L3.49691e-07 12L20 12L20 1C20 0.400001 19.6 8.56743e-07 19 8.30516e-07ZM20 19L20 14L2.62269e-07 14L4.37118e-08 19C1.74849e-08 19.6 0.4 20 1 20L19 20C19.6 20 20 19.6 20 19Z",
    fill: "#F7F6F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_217_734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(20) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon05);
export default __webpack_public_path__ + "static/media/icon05.053412b0411cb1b6a78ea9764cab8222.svg";
export { ForwardRef as ReactComponent };